/*
 * @Author: ZhangYao
 * @Date: 2021-06-28 20:22:50
 */
import { StateType } from '/@/store/types'
import { Module } from 'vuex'
const state = {
  currentSpaceItem: null as null | CShareDiskNS.ShareSpaceItem, //空间列表
  currentSpaceId: '', //当前空间ID
  tmpToken: null as null | CShareDiskNS.tmpToken, //秘钥
  showUploadList: false, //上传队列弹窗是否显示
  noUpload: false, //是否允许拖拽上传
  batchDown: false, //是否批量下载
  selectedRow: {
    //素材选中row
    type: 1, //1代表点击，2代码双击
    list: [],
  } as CShareDiskNS.SelectItem,
}
type SpaceStateType = typeof state

const space: Module<SpaceStateType, StateType> = {
  namespaced: true,
  ...state,
}

export { SpaceStateType, state }
export default space
